import {
  Box,
  Flex,
  Image,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import AdminNavbarLinks from 'components/navbar/NavbarLinksAdmin';
import { removeIdFromRoute } from './RemoveIdFromRoute';
import Logo from '../../assets/img/brand-logo.svg';

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);
  const { secondary, message, brandText } = props;
  const processedBrandText = removeIdFromRoute(brandText) || 'Dashboard';

  const ink = useColorModeValue('#111812', 'white');
  const muted = useColorModeValue('#3D433E', 'whiteAlpha.800');
  const navbarBg = useColorModeValue('rgba(246, 247, 249, 0.94)', 'rgba(7, 50, 5, 0.86)');
  const navbarBorder = useColorModeValue('rgba(17, 24, 18, 0.08)', 'rgba(255,255,255,0.08)');
  const navbarShadow = useColorModeValue(
    scrolled ? '0 8px 24px rgba(17, 24, 18, 0.08)' : '0 4px 16px rgba(17, 24, 18, 0.04)',
    'none'
  );

  useEffect(() => {
    const changeNavbar = () => setScrolled(window.scrollY > 1);
    window.addEventListener('scroll', changeNavbar);
    return () => window.removeEventListener('scroll', changeNavbar);
  }, []);

  return (
    <Box
      position="fixed"
      boxShadow={navbarShadow}
      bg={navbarBg}
      borderColor={navbarBorder}
      backdropFilter="blur(16px)"
      borderRadius="20px"
      borderWidth="1px"
      borderStyle="solid"
      alignItems={{ xl: 'center' }}
      display={secondary ? 'block' : 'flex'}
      minH="72px"
      justifyContent={{ xl: 'center' }}
      mx="auto"
      right={{ base: '12px', md: '24px', xl: '30px' }}
      px={{ base: '14px', md: '20px' }}
      py="10px"
      top={{ base: '12px', md: '16px' }}
      w={{
        base: 'calc(100vw - 6%)',
        md: 'calc(100vw - 8%)',
        xl: 'calc(100vw - 350px)',
        '2xl': 'calc(100vw - 365px)',
      }}
      zIndex={10}
    >
      <Flex
        w="100%"
        flexDirection={{ sm: 'column', md: 'row' }}
        alignItems={{ md: 'center' }}
        gap={{ base: 3, md: 0 }}
      >
        <Flex align="center" gap="14px" minW="0">
          <Flex
            align="center"
            justify="center"
            w="44px"
            h="44px"
            borderRadius="14px"
            bg="white"
            flexShrink={0}
          >
            <Image src={Logo} h="28px" w="auto" alt="Natural Remedies" />
          </Flex>
          <Box minW="0">
            <Text
              color={ink}
              fontWeight="500"
              fontSize={{ base: '18px', md: '22px' }}
              letterSpacing="0.2px"
              lineHeight="1.15"
              noOfLines={1}
            >
              {processedBrandText}
            </Text>
            <Text color={muted} fontSize="13px" fontWeight="400" mt="2px">
              Natural Remedies Admin
            </Text>
          </Box>
        </Flex>
        <Box ms="auto" w={{ sm: '100%', md: 'unset' }}>
          <AdminNavbarLinks
            onOpen={props.onOpen}
            logoText={props.logoText}
            secondary={props.secondary}
            fixed={props.fixed}
            scrolled={scrolled}
          />
        </Box>
      </Flex>
      {secondary ? <Text color="white">{message}</Text> : null}
    </Box>
  );
}

AdminNavbar.propTypes = {
  brandText: PropTypes.string,
  variant: PropTypes.string,
  secondary: PropTypes.bool,
  fixed: PropTypes.bool,
  onOpen: PropTypes.func,
};
